export const NewIssueTimeline = () => {
  return <>New issue timeline placeholder</>
}

try{ NewIssueTimeline.displayName ||= 'NewIssueTimeline' } catch {}